module.exports = __webpack_public_path__ + "img/close_black_24dp.dd4f8c6a.svg";